import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {StocksResponse} from '../models/stock/stocks.response';
import {JobStockResponse} from '../models/stock/jobStock.response';
import {Stock} from '../models/stock/stock.model';
import {JobStock} from '../models/stock/jobStock.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(private http: HttpClient) {
  }

  private STOCK_URL: string = environment.BASE_URL + 'stock';
  private JOB_STOCK_URL: string = environment.BASE_URL + 'job';

  /**
   * GETS
   */
  public getStocks(): Observable<StocksResponse> {
    return this.http.get<StocksResponse>(`${this.STOCK_URL}`).pipe(map(stocks => ({
      stocks: stocks.stocks.sort((s1, s2) => s2.partNumber.localeCompare(s1.partNumber))
    })));
  }

  public getJobStock(id: string): Observable<JobStockResponse> {
    return this.http.get<JobStockResponse>(`${this.JOB_STOCK_URL}/${id}/stock`).pipe(map(jobStock => {
      jobStock.jobStock.costings.forEach(costing => {
        if (costing.estimate) {
          costing.estimate.order = costing.order;
          costing.estimate.costingId = costing.id;
        }
      });
      return jobStock;
    }));
  }

  public getStock(id: string): Observable<Stock> {
    return this.http.get<Stock>(`${this.STOCK_URL}/${id}`).pipe(
    );
  }

  /**
   * CREATES
   */
  public createStock(stock: Stock): Observable<Stock> {
    return this.http.post<Stock>(`${this.STOCK_URL}`, stock).pipe();
  }


  /**
   * UPDATES
   */
  public updateStock(stock: Stock): Observable<Stock> {
    return this.http.patch<Stock>(`${this.STOCK_URL}/${stock.id}`, stock).pipe();
  }

  public updateJobStock(jobStock: JobStock): Observable<JobStockResponse> {
    return this.http.patch<JobStockResponse>(`${this.JOB_STOCK_URL}/${jobStock.id}/stock`, jobStock).pipe(map(jobStock => {
      jobStock.jobStock.costings.forEach(costing => {
        if (costing.estimate) {
          costing.estimate.order = costing.order;
          costing.estimate.costingId = costing.id;
        }
      });
      return jobStock;
    }));
  }

  /**
   * DELETE
   */
  public deleteStock(id: string): Observable<Stock> {
    return this.http.delete<Stock>(`${this.STOCK_URL}/${id}`).pipe();
  }

}
